import { render, staticRenderFns } from "./DocumentsKeywordsSummary.vue?vue&type=template&id=09dbbfe7"
import script from "./DocumentsKeywordsSummary.vue?vue&type=script&lang=js"
export * from "./DocumentsKeywordsSummary.vue?vue&type=script&lang=js"
import style0 from "./DocumentsKeywordsSummary.vue?vue&type=style&index=0&id=09dbbfe7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports